import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import VibeBApp from "./vibe-b";
import "./styles.css";
import "./vibe-b-stabilize.css";

document.body.classList.add("vibe-b-root");

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <VibeBApp />
  </StrictMode>,
);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // PWA installability should not block the learning experience.
    });
  });
}
